import { render, staticRenderFns } from "./AaprobarPostgrado.vue?vue&type=template&id=0f3687ec&scoped=true"
import script from "./AaprobarPostgrado.vue?vue&type=script&lang=js"
export * from "./AaprobarPostgrado.vue?vue&type=script&lang=js"
import style0 from "./AaprobarPostgrado.vue?vue&type=style&index=0&id=0f3687ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3687ec",
  null
  
)

export default component.exports